var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.882,
    cy: 21.7722,
    r: 21.2277,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1481_364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5452 19.4077L23.5258 19.4072C23.1275 19.4072 22.8047 19.73 22.8047 20.1283V23.0096C22.8047 23.4078 23.1275 23.7306 23.5258 23.7306H28.6049C28.0487 25.174 27.0107 26.3828 25.6863 27.1509L27.852 30.9C31.3261 28.8907 33.3801 25.3653 33.3801 21.4189C33.3801 20.857 33.3386 20.4553 33.2558 20.003C33.1928 19.6594 32.8945 19.4077 32.5452 19.4077Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3229 28.0599C19.8373 28.0599 17.6673 26.7018 16.5019 24.6921L12.7529 26.853C14.6608 30.1596 18.2347 32.3862 22.3229 32.3862C24.3284 32.3862 26.2208 31.8462 27.8509 30.9052V30.9001L25.6852 27.1509C24.6946 27.7255 23.5482 28.0599 22.3229 28.0599Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8523 30.9052V30.9L25.6865 27.1509C24.6959 27.7254 23.5496 28.0599 22.3242 28.0599V32.3862C24.3297 32.3862 26.2222 31.8462 27.8523 30.9052Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5939 21.33C15.5939 20.1048 15.9282 18.9586 16.5027 17.968L12.7537 15.8071C11.8075 17.4322 11.2676 19.3194 11.2676 21.33C11.2676 23.3407 11.8075 25.2279 12.7537 26.853L16.5027 24.6921C15.9282 23.7015 15.5939 22.5552 15.5939 21.33Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3229 14.6002C23.9438 14.6002 25.4326 15.1762 26.5956 16.1342C26.8825 16.3705 27.2994 16.3535 27.5622 16.0907L29.6037 14.0492C29.9019 13.751 29.8807 13.263 29.5621 12.9866C27.6137 11.2963 25.0786 10.2739 22.3229 10.2739C18.2347 10.2739 14.6608 12.5006 12.7529 15.8071L16.5019 17.968C17.6673 15.9583 19.8373 14.6002 22.3229 14.6002Z",
    fill: "#FE724C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5969 16.1342C26.8838 16.3705 27.3008 16.3535 27.5636 16.0907L29.6051 14.0492C29.9032 13.751 29.8819 13.263 29.5635 12.9866C27.615 11.2963 25.0799 10.2739 22.3242 10.2739V14.6002C23.9451 14.6002 25.434 15.1762 26.5969 16.1342Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1481_364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1122,
    height: 22.1122,
    fill: "white",
    transform: "translate(11.2676 10.2739)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e8d0244e569ac0ccbf563b21de371f8d.svg";
export { ForwardRef as ReactComponent };